import _implicitStylesheets from "./pricingCard.css";
import _implicitScopedStylesheets from "./pricingCard.scoped.css?scoped=true";
import _axBadge from "ax/badge";
import _axCard from "ax/card";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<span type-style="body-2" class="pricing-card__plan-name${0}" data-testid="plan-name"${2}>${"t1"}</span>`;
const $fragment2 = parseFragment`<span type-style="body-2" class="pricing-card__trial-period${0}" data-testid="trial-period"${2}>${"t1"}</span>`;
const $fragment3 = parseFragment`<span type-style="display-6" class="pricing-card__price${0}" data-testid="plan-price"${2}>${"t1"}</span>`;
const $fragment4 = parseFragment`<span type-style="display-8" class="pricing-card__unit${0}" data-testid="plan-unit-frequency"${2}>${"t1"}</span>`;
const stc0 = {
  classMap: {
    "pricing-card__header": true
  },
  key: 1
};
const stc1 = {
  "data-testid": "lowest-starting-price-badge"
};
const stc2 = {
  classMap: {
    "pricing-card__price-block": true
  },
  key: 7
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, c: api_custom_element, h: api_element} = $api;
  return [api_custom_element("ax-card", _axCard, {
    className: api_normalize_class_name($cmp.cardClass),
    props: {
      "role": "group",
      "ariaLabel": $cmp.planName,
      "padding": "large",
      "border": "true"
    },
    key: 0
  }, [$cmp.hasHeaderContent ? api_element("div", stc0, [$cmp.hasPlanName ? api_static_fragment($fragment1, 3, [api_static_part(1, null, api_dynamic_text($cmp.planName))]) : null, $cmp.showLowestStartingPriceBadge ? api_custom_element("ax-badge", _axBadge, {
    attrs: stc1,
    props: {
      "text": $cmp.lowestStartingPriceLabel,
      "theme": "green"
    },
    key: 4
  }) : null]) : null, $cmp.hasTrialPeriodLabel ? api_static_fragment($fragment2, 6, [api_static_part(1, null, api_dynamic_text($cmp.trialPeriodLabel))]) : null, api_element("div", stc2, [api_static_fragment($fragment3, 9, [api_static_part(1, null, api_dynamic_text($cmp.formattedPrice))]), $cmp.hasUnitFrequencyLabel ? api_static_fragment($fragment4, 11, [api_static_part(1, null, api_dynamic_text($cmp.unitFrequencyLabel))]) : null])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-28k97cedpe2";
tmpl.legacyStylesheetToken = "undefined-_pricingCard";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
